import { useTheme } from '@/contexts/ThemeContext';

export function useDarkMode() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  
  return {
    isDark,
    // Background colors
    bgPrimary: isDark ? '#20212B' : '#FFFAF5',
    bgSecondary: isDark ? '#2D4354' : '#FFFFFF',
    bgTertiary: isDark ? '#1a1b23' : '#F8F4F1',
    
    // Text colors
    textPrimary: isDark ? '#FFFAF5' : '#20212B',
    textSecondary: isDark ? '#A8A9A6' : '#73766A',
    textMuted: isDark ? '#8a8b88' : '#9CA3AF',
    
    // Border colors
    borderPrimary: isDark ? '#3A3B45' : '#E5E7EB',
    borderSecondary: isDark ? '#4a4b55' : '#D1D5DB',
    
    // Accent colors (remain same)
    accentPrimary: '#FED7A5',
    accentSecondary: '#9E6752',
    accentTertiary: '#534145',
    
    // Utility classes
    bgClass: isDark ? 'bg-[#20212B]' : 'bg-[#FFFAF5]',
    cardClass: isDark ? 'bg-[#2D4354]' : 'bg-white',
    textClass: isDark ? 'text-[#FFFAF5]' : 'text-[#20212B]',
    textSecondaryClass: isDark ? 'text-[#A8A9A6]' : 'text-[#73766A]',
    borderClass: isDark ? 'border-[#3A3B45]' : 'border-[#E5E7EB]',
  };
}
